export default class Strings {
  static getHostName (url) {
    let match = url.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/)
    return _.isNull(match) ? '' : (match[3] || '')
  }
}
